import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  accountName: yup.string().required("Account name is required"),
  accountType: yup.string().required("Account type is required"),
  subAccountType: yup.string().required("Sub account type is required"),
});

const Validation = ({ bankDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      accountType: bankDetails?.account_type,
      accountName: bankDetails?.account_name,
      subAccountType: bankDetails?.sub_account_type,
    },
  });
};

export default Validation;
